/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_products = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_products">;
    readonly " $refType": "StorefrontHome_products";
};
export type StorefrontHome_products$data = StorefrontHome_products;
export type StorefrontHome_products$key = {
    readonly " $data"?: StorefrontHome_products$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_products">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontHome_products",
  "type": "DealerStorefrontQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "DealerStorefrontQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_products",
      "args": null
    }
  ]
};
(node as any).hash = '8ff47b8ca9e101479ded1d4a9355a1ae';
export default node;
